import { render, staticRenderFns } from "./EmergencyIncidentList.vue?vue&type=template&id=3518d31b"
import script from "./EmergencyIncidentList.vue?vue&type=script&lang=js"
export * from "./EmergencyIncidentList.vue?vue&type=script&lang=js"
import style0 from "./EmergencyIncidentList.vue?vue&type=style&index=0&id=3518d31b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports